import { render, staticRenderFns } from "./VekilSorgulaView.vue?vue&type=template&id=43432c46"
import script from "./VekilSorgulaView.vue?vue&type=script&lang=ts"
export * from "./VekilSorgulaView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports